import LoginWithToken from './LoginWithToken';

export default {
  name: 'LoginWithToken',
  path: '/loginWithToken',
  component: LoginWithToken,
};
